<style scoped lang="scss">
.wrapper {
  background: url("../images/register_bg.jpg") no-repeat center center fixed;
  background-size: cover;

  min-height: 60vh;
}

.image-wrapper {
  width: 100px;
  height: 100px;
}

.previosButton {
  top: 36px;
  left: -70px;
  z-index: 0;
}
</style>

<template>
  <div class="position-relative">
    <div
      style="flex-direction: column;"
      class="d-flex justify-content-center align-items-center"
      :class="{
        'position-fixed fixed-top fixed-left w-100 h-100': fullscreen,
        wrapper: !noBackground
      }"
    >
      <div class="d-flex mb-2">
        <div class="image-wrapper position-relative">
          <img
            class="border h-100 rounded-circle shadow"
            src="../images/assistance.jpg"
          />
        </div>
        <span
          style="margin-left: 10px; opacity: 0.9;"
          class="card card-body shadow"
          ><p v-html="getMessage(step)"></p
        ></span>
      </div>
      <div style="position: relative;">
        <SquareButton
          v-show="step !== 0 && step !== 6"
          class="previosButton position-absolute"
          @click.native="previosStep"
          direction="left"
        />
        <component
          v-for="(component, key, index) in $options.components"
          :is="component"
          :key="key"
          :text="noBackground ? 'black' : 'white'"
          v-if="index === step"
          :errors="errors"
          :meta="meta"
          :working="working"
          v-model="registration[stepToAttribute]"
          @input="validateAndContinue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Birthday from "./signup/BirthdaySelector";
import Postcode from "./signup/PostcodeSelector";
import Username from "./signup/UsernameSelector";
import Email from "./signup/EmailSelector.vue";
import Password from "./signup/PasswordSelector.vue";
import TOS from "./signup/TOSSelector.vue";
import Confirm from "./signup/ConfirmComponent.vue";
import SquareButton from "./signup/SquareButton.vue";

export default {
  components: {
    Birthday,
    Postcode,
    Username,
    Email,
    Password,
    TOS,
    Confirm,
    SquareButton
  },
  data() {
    return {
      step: 0,
      working: false,
      registration: {},
      errors: null,
      meta: null,
      attributes: ["birthday", "location", "name", "email", "password", "legal"]
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    noBackground: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.addEventListener("popstate", () => {
      const hash = window.location.href.split("#")[1];

      if (hash) this.step = parseInt(hash, 10);
    });
    this.loadMeta();
  },
  methods: {
    getMessage(step) {
      let messages = [
        `Hallo ich bin ${Laravel.lang.assitance} und helfe dir durch die kostenlose Registrierung. Verrätst du mir dein Geburtsdatum damit ich weiß in welcher Altersrubrik du suchst?`,
        "Ich würde dir gerne Mitglieder in deiner Nähe vorschlagen, gebe bitte die Postleitzahl deines Wohnorts ein.",
        "Wie soll dein Benutzername lauten?",
        "Nun brauche ich noch deine E-Mail-Adresse, um dir ein Profil erstellen zu können…",
        "Fast geschafft!  Lege bitte noch ein Passwort fest",
        "Bestätige noch bitte unsere AGB und Datenschutzbestimmung",
        `Jetzt musst du nur noch deine Angaben bestätigen und dein Benutzerkonto aktivieren. Ich habe dir dazu eine E-Mail an <b>${this.registration["email"]}</b> zukommen lassen. <br><br><b>Bitte schaue auch in deinem Spam-Ordner nach, gelegentlich landen dort auch E-Mails.</b>`
      ];
      return messages[step];
    },
    validateAndContinue() {
      this.errors = null;
      this.working = true;
      this.$http
        .post(`/api/v1/register/validate-step/${this.step}`, {
          [this.stepToAttribute]: this.registration[this.stepToAttribute]
        })
        .then(() => {
          this.working = false;
          this.nextStep();
        })
        .catch(({ response }) => {
          this.working = false;
          this.errors = response.data;
        });
    },
    injectOnRegisterScript() {
      const el = document.createElement("script");
      el.text = atob(Laravel.inject.injectScriptAfterRegister);
      document.body.appendChild(el);
    },
    async nextStep() {
      this.step++;
      if (this.step >= 6) {
        this.step--;
        this.registerUser();
        this.injectOnRegisterScript();
        return;
      }
      await this.loadMeta();
      history.pushState({}, this.step, `#${this.step}`);
    },
    async previosStep() {
      this.step--;
      await this.loadMeta();
      history.pushState({}, this.step, `#${this.step}`);
    },
    async loadMeta() {
      const response = await this.$http.get(
        `/api/v1/register/validate-step/${this.step}/meta`
      );
      this.meta = response.data;
    },
    registerUser() {
      let registration = {};
      [
        ...window.location.href.matchAll(new RegExp("[?&](.*?)=([^&#]*)", "g"))
      ].forEach(function(element) {
        registration[element[1]] = element[2];
      });

      this.registration = { ...registration, ...this.registration };
      this.working = true;
      this.$http
        .post(`/api/v1/register`, this.registration)
        .then(() => this.step++)
        .catch(error => {
          console.log(error);
        })
        .finally(() => (this.working = false));
    }
  },
  computed: {
    stepToAttribute() {
      return this.attributes[this.step];
    }
  }
};
</script>
